<template>
  <div class="flex lg:items-center justify-between mb-6 flex-col lg:flex-row">
    <ul class="tabs__header">
      <Link :class="(button.link === currentUrl) ? 'tab_selected' : ''" :href="button.link" v-for="(button, key) in buttons" v-bind:key="key">
        <li class="m-1">
          {{ button.text }}
        </li>
      </Link>
    </ul>
  </div>
</template>
<script>
import {Link} from '@inertiajs/inertia-vue3'

export default{
  components: {Link},
  props:{
    buttons: Array,
  },
  computed: {
    currentUrl() {
      return window.location.href
    },
  }
}
</script>
